// --------------------------------------------------------------
// Created On: 2025-06-18
// Author: Zachary Thomas
//
// Last Modified: 2025-06-18
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

// Takes a date range and attempts to figure out what data for a date label should be removed due to redundancy.
// For example, a date range that is all under the same year should drop the year. A date range for hours over
// the same day should drop the day.
// Expected format of labels:
// MINUTE: "6/12/2025, 5:00 AM"
// HOUR: "6/12/2025, 5 AM"
// DAY: "6/12/2025"
// WEEK: "6/12/2025 - 6/14/2025"
export default function formatDateLabelForMinimumText(
  startDate: Date,
  endDate: Date,
  dateScale: DateScale,
  label: string
): string {
  let newLabel = label;
  if (dateScale === "MINUTE" || dateScale === "HOUR") {
    if (startDate.getFullYear() === endDate.getFullYear() && startDate.getDate() === endDate.getDate()) {
      const labelSections = label.split(", ");
      if (labelSections.length === 2) {
        newLabel = labelSections[1];
      }
    } else if (startDate.getFullYear() === endDate.getFullYear()) {
      newLabel = label.replace(`/${startDate.getFullYear()}`, "");
    }
  } else if (dateScale === "DAY") {
    if (startDate.getFullYear() === endDate.getFullYear()) {
      newLabel = label.replace(`/${startDate.getFullYear()}`, "");
    }
  } else if (dateScale === "WEEK") {
    if (startDate.getFullYear() === endDate.getFullYear()) {
      newLabel = label.replaceAll(`/${startDate.getFullYear()}`, "");
    }
  }
  return newLabel;
}

type DateScale = "MINUTE" | "HOUR" | "DAY" | "WEEK";
